export default "__VITE_ASSET__0$L1RQbh__"